import React from 'react';
import { Field, FieldProps, FieldRenderProps } from 'react-final-form';
import { BaseInputProps } from '../InputField';
import CheckboxInputFieldWithCallback from './CheckboxInputFieldWithCallback';

export type InputFieldProps = FieldProps<boolean, FieldRenderProps<boolean, HTMLElement>> & BaseInputProps;

/**
 * Component that renders a checkbox field with on change event
 */
export default function CheckboxFieldWithCallback({
	name,
	readOnly = false,
	disabled = false,
	label = '',
	afterSubmit,
	allowNull,
	beforeSubmit,
	formatOnBlur,
	initialValue,
	isEqual,
	subscription,
	checked,
	onChange,
}: InputFieldProps) {
	return (
		<Field
			name={name}
			type="checkbox"
			afterSubmit={afterSubmit}
			allowNull={allowNull}
			beforeSubmit={beforeSubmit}
			formatOnBlur={formatOnBlur}
			initialValue={initialValue}
			isEqual={isEqual}
			subscription={subscription}
			checked={checked}
			onChange={onChange}
		>
			{({ input, meta }) => (
				<CheckboxInputFieldWithCallback
					name={name}
					input={input}
					meta={meta}
					readOnly={readOnly}
					disabled={disabled}
					label={label}
					type="checkbox"
					onChange={(value) => {
						input.onChange(value);
						if (onChange) {
							onChange(value);
						}
					}}
				/>
			)}
		</Field>
	);
}
